import api from './auth';
import {
  Server,
  UpdateServerDto,
  ServerPpp,
  ServerStaticIp,
  CreateServerPppBatchDto,
  CreateServerStaticIpBatchDto,
} from '../types/api';

// 获取服务器列表
export const getServerList = (params?: { status?: string }) => {
  return api.get<Server[]>('/servers', { params });
};

// 获取在线服务器列表
export const getOnlineServers = () => {
  return api.get<Server[]>('/servers', { params: { status: 'online' } });
};

// 获取单个服务器详情
export const getServerDetail = (deviceId: string) => {
  return api.get<Server>(`/servers/${deviceId}`);
};

// 更新服务器
export const updateServer = (deviceId: string, data: UpdateServerDto) => {
  return api.patch<Server>(`/servers/${deviceId}`, data);
};

// 删除服务器
export const deleteServer = (deviceId: string) => {
  return api.delete(`/servers/${deviceId}`, {
    validateStatus: (status) => status === 204 || status < 500 // 接受204状态码
  });
};

// 获取PPP配置列表
export const getPppConfigs = (deviceId: string) => {
  return api.get<ServerPpp[]>(`/servers/${deviceId}/ppp`);
};

// 批量写入PPP配置（后端语义：先清空PPP+静态IP两表再插入，并经MQTT下发 pppoe_conf 到设备）
export const addPppBatch = (deviceId: string, data: CreateServerPppBatchDto) => {
  return api.post<ServerPpp[]>(`/servers/${deviceId}/ppp`, data);
};

// 获取静态IP配置列表
export const getStaticIpConfigs = (deviceId: string) => {
  return api.get<ServerStaticIp[]>(`/servers/${deviceId}/static-ip`);
};

// 批量写入静态IP配置（后端语义：先清空PPP+静态IP两表再插入，并经MQTT下发 static_ip_config 到设备）
export const addStaticIpBatch = (deviceId: string, data: CreateServerStaticIpBatchDto) => {
  return api.post<ServerStaticIp[]>(`/servers/${deviceId}/static-ip`, data);
};

// 清空设备网络配置（PPP + 静态IP + 回传地址，仅平台侧，不下发设备）
export const clearNetworkConfig = (deviceId: string) => {
  return api.delete<{ message: string }>(`/servers/${deviceId}/network`);
};

